
import LoginPage from '~/pages/_lang/login.vue'
export default LoginPage
